import { APIGet, APIPost } from '../services/API'


/*
args {
    page: int
}
*/
export const getRequests = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    if(args.page <= 1){
        // Dispatch Result
        dispatch({
            type: 'GETTING_PRAYER_REQUESTS',
            payload: {
                ui: "loading"
            }
        });
    }

    let url = site+'/api/v1/prayer/requests';
    let qs = [];

    if(args.page) qs.push('page='+args.page);
    if(args.total) qs.push('total='+args.total);
    if(args.category) qs.push('category='+args.category);


    let queryString = qs.join('&');

    url += '?'+queryString;

    // Send Request To Get Events
    APIGet(url)
    .then(res => res.json())
    .then(json => {

        let loadedRequests = [...json];

        if(args.page > 1){

            // Merge Results
            const { requests } = getState().Prayer;
            loadedRequests = [...requests,...loadedRequests];

        }

        dispatch({ type: 'GET_PRAYER_REQUESTS_SUCCESS',payload: {ui:"success",requests:loadedRequests}});
    })
    .catch(e => {
        dispatch({ type: 'GET_PRAYER_REQUESTS_ERROR',payload: {ui:"error",message:e}});
    })

}

export const newPrayerRequest = (args) => (dispatch, getState) => {

    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'POSTING_PRAYER_REQUESTS',
        payload: {
            ui: "loading"
        }
    });

    APIPost(site+'/api/v1/prayer/requests/create',args)
    .then(res => res.json())
    .then(json => {

        // Success
        dispatch({ type: 'POSTING_PRAYER_REQUESTS_SUCCESS',payload: {ui:"success",requests:json}});

        // Refressh List
        let get = {
            total: args.total,
            page: args.page
        }
        dispatch(getRequests(get));


    })
    .catch(e => {
        dispatch({ type: 'POSTING_PRAYER_REQUESTS_ERROR',payload: {ui:"error",message:e}});
    })

}

export const incrementPrayer = (itemId,nonce) => (dispatch, getState) => {

    const { site } = getState().Settings;
    const { requests } = getState().Prayer;


    // Dispatch Result

    APIPost(site+'/api/v1/prayer/requests/prayed',{id:itemId,nonce:nonce})
    .then(res => res.json())
    .then(json => {

        // Update Requests
        const currentRequests = [...requests];
        const newRequest = currentRequests.map(item => {
            if(item.id === itemId) return json;
            return item;
        })

        dispatch({ type: 'PRAYED_FOR_REQUEST_SUCCESS',payload: {requests:newRequest}});
    })
    .catch(e => {
        dispatch({ type: 'PRAYED_FOR_REQUEST_ERROR',payload: {message:e}});
    })



}
